module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-BLOG-PLOT-01-09-6f57747760db2c272a8b6d0354f696cd.png";